import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, Grid, FormLabel, InputAdornment } from '@mui/material';
import GlobalDialogContent from '../GlobalDialogContent';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { CommitmentStatusUpdate } from '../../../utils/services/project/project';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { RootState } from '../../../redux/store';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import "react-quill/dist/quill.snow.css";
import "draft-js/dist/Draft.css";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

import { AmountDisplay, rupeeAmountDisplay } from '../../../utils/utils';
import React from 'react';

const ApproveCommit = () => {
    const dispatch = useDispatch();
    const projectData = useSelector((state: RootState) => state.dialog.payload);

    const formik = useFormik({
        initialValues: {
            unitsCommitted: projectData?.no_of_unit,
            costPerUnit: projectData?.cost,
            totalCommitment: projectData?.total_implementation,
            AppunitsCommitted: projectData?.no_of_unit,
            AppcostPerUnit: projectData?.cost,
            ApptotalCommitment: projectData?.total_implementation,
            approveComment: 0,
            comment: ''
        },
        validationSchema: Yup.object({
            unitsCommitted: Yup.number().min(1, 'Minimum 1 unit required').required('Required'),
            costPerUnit: Yup.number().min(0, 'Cost per unit must be positive').required('Required'),
            totalCommitment: Yup.string(),
            AppunitsCommitted: Yup.number().min(1, 'Minimum 1 unit required').required('Required'),
            AppcostPerUnit: Yup.number().min(0, 'Cost per unit must be positive').required('Required'),
            ApptotalCommitment: Yup.string(),
            approveComment: Yup.string(),
            comment: Yup.string().required("Comment is Required.!")
        }),
         onSubmit: async (values, { setSubmitting }) => {
             if (projectData?.id) {
                 const reqPayload = {
                     request_id: projectData?.id,
                     user_id: projectData?.user_id,
                     status: "approved",
                     no_of_unit: Number(values?.AppunitsCommitted),
                     cost: Number(values?.AppcostPerUnit),
                     total_implementation: Number(values?.ApptotalCommitment),
                     comment: values.comment
                 };

                 const { code ,message} = await CommitmentStatusUpdate(reqPayload);

                 if (code === 200) {
                     dispatch(showSnackbar({ type: "success", message: message || "Status updated successfully!" }));
                     dispatch(setModuleRefresh({ moduleName: 'approveCommitment', refresh: true }));
                     dispatch(closeDialog());
                 } else {
                     dispatch(showSnackbar({ type: "error", message: message || "Failed to update status" }));
                 }
             }
         }
    });

    React.useEffect(() => {
        const total = Number(formik.values.AppunitsCommitted) * Number(formik.values.AppcostPerUnit);
        formik.setFieldValue('ApptotalCommitment', total);
    }, [formik.values.AppunitsCommitted, formik.values.AppcostPerUnit]);

    
    return (

        <>
            <form onSubmit={formik.handleSubmit}>
                <GlobalDialogContent
                    dialogBody={
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="No. of Units Committed"
                                    name="unitsCommitted"
                                    type="text"
                                    size='small'                                    
                                    value={AmountDisplay(formik.values.unitsCommitted)}
                                    InputProps={{
                                        disabled: true,
                                        style: { textAlign: "right" }
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9]/g, ""); 
                                        formik.setFieldValue(e.target.name, value);
                                    }}                                    
                                    error={formik.touched.unitsCommitted && Boolean(formik.errors.unitsCommitted)}
                                    helperText={formik.touched.unitsCommitted && Boolean(formik.errors.unitsCommitted)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Cost per Unit"
                                    name="costPerUnit"
                                    type="text"
                                    size='small'
                                    value={AmountDisplay(formik.values.costPerUnit)}
                                    InputProps={{
                                        disabled: true,
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9]/g, ""); 
                                        formik.setFieldValue(e.target.name, value);
                                        formik.setFieldValue('totalCommitment', Number(value) * Number(formik.values.unitsCommitted)); 
                                    }}
                                    inputProps={{
                                        style: { textAlign: "right" }
                                    }}
                                    error={formik.touched.costPerUnit && Boolean(formik.errors.costPerUnit)}
                                    helperText={formik.touched.costPerUnit && Boolean(formik.errors.costPerUnit)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Total Commitment"
                                    name="totalCommitment"
                                    type="text"
                                    InputProps={{
                                    disabled: true,
                                    }}
                                    autoFocus      
                                    inputProps={{ maxLength: 15, style: { textAlign: 'right' } }}
                                    size='small'
                                    value={rupeeAmountDisplay(formik.values.totalCommitment)}
                                 
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Approve No. of Units"
                                    name="AppunitsCommitted"
                                    type="text"
                                    size='small'                                    
                                    value={AmountDisplay(formik.values.AppunitsCommitted)}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9]/g, ""); 
                                        if (value <= formik.values.unitsCommitted) {
                                            formik.setFieldValue('AppunitsCommitted', value);
                                        }
                                    }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}                                    
                                    error={formik.touched.AppunitsCommitted && Boolean(formik.errors.AppunitsCommitted)}
                                    helperText={formik.touched.AppunitsCommitted && Boolean(formik.errors.AppunitsCommitted)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Approve Cost per Unit"
                                    name="AppcostPerUnit"
                                    type="text"
                                    size='small'
                                    value={AmountDisplay(formik.values.AppcostPerUnit)}    
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/[^0-9]/g, ""); 
                                        if (value <= formik.values.costPerUnit) {
                                            formik.setFieldValue('AppcostPerUnit', value);
                                        }
                                    }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                    error={formik.touched.AppcostPerUnit && Boolean(formik.errors.AppcostPerUnit)}
                                    helperText={formik.touched.AppcostPerUnit && Boolean(formik.errors.AppcostPerUnit)}
                                />
                            </Grid>
                            
                            <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Approve Total Commitment"
                                name="ApptotalCommitment"
                                type="text"
                                inputProps={{ maxLength: 15, style: { textAlign: 'right' } }}
                                InputProps={{
                                readOnly: true,
                                startAdornment: (
                                    <InputAdornment position="start">
                                    <CurrencyRupeeIcon fontSize="small"  sx={{fontSize: 20, ml: 1}} />
                                    </InputAdornment>
                                ),
                                }}
                                focused
                                size="small"
                                value={AmountDisplay(formik.values.ApptotalCommitment)}
                            />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} sx={{my: 1}}>
                            <FormLabel>Remarks: <span style={{color: 'red'}}>*</span> </FormLabel>
                            <TextField
                                        name="comment"
                                        value={formik.values.comment}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.comment && Boolean(formik.errors.comment)}
                                        helperText={formik.touched.comment && formik.errors.comment}
                                        placeholder="Enter Comments"
                                        multiline
                                        rows={3}
                                        size="small"
                                        fullWidth
                                    />
                            </Grid>
                        </Grid>
                    }
                    dialogFooter={
                        <>
                            <Button type="submit" variant="contained" color="success">
                                Approve
                            </Button>
                        </>
                    }
                />
            </form>
        </>
    );
};

export default ApproveCommit;